import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useTranslation as p } from "react-i18next";
import c from "../link-wrapper/link-wrapper.js";
import e from "./breadcrumbs-list.module.less.js";
const N = ({ items: s }) => {
  let r = [...s];
  s.map((l) => l.title?.length || 0).reduce((l, a) => l + a, 0) > 33 && (r = r.slice(-2)), r.length < s.length && (r = [{ title: "..." }, ...r]);
  const { t: o } = p();
  return /* @__PURE__ */ i("nav", { className: e.wrapper, "aria-label": o("BREADCRUMBS_ARIA_LABEL"), children: [
    /* @__PURE__ */ t("ul", { className: `${e.list} ${e.mobile}`, children: r.map((l, a) => {
      const n = a === r.length - 1;
      return /* @__PURE__ */ i("li", { className: `${n ? e.lastItem : ""}`, children: [
        /* @__PURE__ */ t(
          c,
          {
            className: [l.url ? e.link : e.unlinked].join(" "),
            title: l.title,
            url: l.url ?? void 0
          }
        ),
        !n && /* @__PURE__ */ t("span", { className: e.separator, children: "/" })
      ] }, l.title);
    }) }),
    /* @__PURE__ */ t("ul", { className: `${e.list} ${e.desktop}`, children: s.map((l, a) => {
      const n = a === s.length - 1;
      return /* @__PURE__ */ i("li", { className: `${n ? e.lastItem : ""}`, children: [
        /* @__PURE__ */ t(
          c,
          {
            className: [l.url ? e.link : e.unlinked].join(" "),
            title: l.title,
            url: l.url ?? void 0
          }
        ),
        !n && /* @__PURE__ */ t("span", { className: e.separator, children: "/" })
      ] }, l.title);
    }) })
  ] });
};
export {
  N as BreadcrumbsList
};
